export default __webpack_public_path__ + "static/p-beasley-96b5f5b0199eb58549184643eb0d0f4c.png";